"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const ThemeContext_1 = require("../../../interface/ThemeContext");
const Hero_1 = __importDefault(require("./Hero"));
const Footer_1 = __importDefault(require("../Footer"));
const Ticket_1 = __importDefault(require("./Ticket"));
const ScrollToTop_1 = __importDefault(require("../../hooks/ScrollToTop"));
const connector = (0, react_redux_1.connect)((state) => ({}), (dispatch) => ({}));
exports.default = connector(({}) => {
    const themeContext = (0, ThemeContext_1.useThemeContext)();
    const currentColor = themeContext.colors.white;
    return (react_1.default.createElement("main", null,
        react_1.default.createElement(ScrollToTop_1.default, null),
        react_1.default.createElement(Hero_1.default, null),
        react_1.default.createElement(Ticket_1.default, null),
        react_1.default.createElement(Footer_1.default, null)));
});
